<template>
  <div id="app">
    <van-popup
      v-model="Loadshow"
      style="border-radius:4px;"
      overlay-class="overOpa"
      @click="closeScreen()"
    >
      <ListScreen @closeScreen="closeScreen"/>
    </van-popup>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>
import ListScreen from "@/components/ListScreen.vue";
import { setInterval, setTimeout, clearTimeout } from "timers";
import { Swipe, SwipeItem } from "vant";
import { screen } from "./api/http.js";
import Vue from "vue";
Vue.use(Swipe).use(SwipeItem);
// import { activeHome } from "../api/http.js";
export default {
  components: {
    ListScreen
  },
  data() {
    return {
      list: [],
      t: null,
      timer: null,
      Loadshow: false
    };
  },
  created() {
    this.hasOperate(this.showScreen, 300000);
  },
  computed: {
  },
  methods: {
    hasOperate(callback, second) {
      //second是检测未操作的时间，秒为单位，callback是该时间段未点击需要执行的函数
      var status = true;
      var timer = null;
      document.body.addEventListener("touchstart", function() {
        sessionStorage.removeItem("screen");
        status = true;
      });
      document.body.addEventListener("touchend", function() {
        countTime();
      });
      setInterval(function() {
        if (!status && sessionStorage.getItem("screen") == null) {
          callback();
          sessionStorage.setItem("screen", "1");
          status = true;
        }
      }, 1);
      function countTime() {
        clearTimeout(timer);
        timer = setTimeout(function() {
          status = false;
        }, second);
      }
      countTime();
    },
    showScreen() {
      this.Loadshow = true;
    },
    closeScreen() {
      sessionStorage.removeItem("screen");
      this.Loadshow = false;
    }
  }
};
</script>


<style lang="scss">
@import url("https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.7.2/animate.min.css"); //animate
@import url("//at.alicdn.com/t/font_1161655_0ch2ha26t9ve.css"); //iconfont
input[type="button"],
input[type="submit"],
input[type="reset"] {
  -webkit-appearance: none;
}
textarea {
  -webkit-appearance: none;
}
</style>
<style>
html,
body {
  min-height: 100%;
}
body {
  background: rgba(250, 250, 250, 1);
}
.overOpa {
  background-color: rgba(0, 0, 0, 1) !important;
}
</style>
